import React from "react";
import Styles from './styles.module.scss';
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import LangSwitcher from "../langSwitcher";


const LoginContent = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <LangSwitcher isVertical={true} isPublicStyle={true}/>
                {authStatus ?
                    <div className={Styles.btnsWrap}>
                        <div className={`${Styles.ftfBorderBtn}`} onClick={()=>{navigate('/matrix')}} style={{gridColumn: '1 / 3'}}>{t('Кабинет')}</div>
                    </div> :
                    <div className={Styles.btnsWrap}>
                        <div className={`${Styles.ftfBorderBtn}`} onClick={()=>{navigate('/sign-in')}}>{t('Вход')}</div>
                        <div className={`${Styles.ftfBorderBtn}`} onClick={()=>{navigate('/sign-up')}}>{t('Регистрация')}</div>
                    </div>
                }
            </div>
        </section>
    );
};

export default LoginContent;

// <div className={`${Styles.ftfBorderBtn}`}>
//     Login
//     <LoginButton
//         botUsername={process.env.REACT_APP_BOT_USERNAME}
//         // botUsername="FTFLocalBot"
//         onAuthCallback={(data) => {
//             dispatch(telegramWidgetAuthorization(data));
//             console.log('tel data:', data);
//             // call your backend here to validate the data and sign in the user
//         }}
//         showAvatar={false}
//     />
// </div>
